import Vue from 'vue';
import { Component, Inject, Prop, Emit, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import vuejsDatepicker from 'vuejs-datepicker';
import Autocomplete from 'vuejs-auto-complete';
import { Task, DisplayOptions, Category, Employee, Project } from '@/types/store-types';
import { PossibleUpdates } from '@/types/crm-types';
import Language from '@/models/datepicker-language';

const project = namespace('project');
@Component({ components: { vuejsDatepicker, Autocomplete } })
export default class TaskComponent extends Vue {
  private nl = new Language(
    'Dutch',
    ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
    ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
    ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za']);

  private taskData: Task = {
    taskId: '',
    categoryKey: '',
    category: '',
    name: '',
    startDate: new Date(),
    employeeId: '',
    plannedHours: 0,
    tariff: 0,
    possibleActions: PossibleUpdates.None,
    newTask: false,
  };

  @Prop()
  private tabIndex: number;

  @Prop()
  private task: Task;

  @Prop()
  private category: Category;

  @project.Getter('project')
  private project: Project;

  @project.Getter('employees')
  private employees: Employee[];

  @project.Getter('employeeList')
  private employeeList: Employee[];

  @project.Getter('displayOptions')
  private displayOptions: DisplayOptions;

  @project.Action('selectTask')
  private selectTask(id: string) {
  }

  @project.Action('createTask')
  private async createTask(task: Task) {
  }

  @project.Action('updateTask')
  private async updateTask(task: Task) {
  }

  get employeeName(): string {
    const employee = this.employee;
    return (employee && employee.name) || '';
  }

  get employee(): Employee | undefined {
    const employee = this.employees.find((e) => e.employeeId === this.task.employeeId);
    return employee;
  }

  get AllowNameChange(): boolean {
    return this.project.isClosed;
  }

  get AllowTariffChange(): boolean {
    if (this.project.isClosed) {
      return false;
    }

    return (this.task.possibleActions & PossibleUpdates.Tariff) === PossibleUpdates.Tariff;
  }

  get AllowEmployeeChange(): boolean {
    if (this.project.isClosed) {
      return false;
    }

    return (this.task.possibleActions & PossibleUpdates.Owner) === PossibleUpdates.Owner;
  }

  get AllowStartDateChange(): boolean {
    if (this.project.isClosed) {
      return false;
    }

    return (this.task.possibleActions & PossibleUpdates.StartDate) === PossibleUpdates.StartDate;
  }

  get AllowEndDateChange(): boolean {
    if (this.project.isClosed) {
      return false;
    }

    return (this.task.possibleActions & PossibleUpdates.EndDate) === PossibleUpdates.EndDate;
  }

  get AllowDelete(): boolean {
    if (this.project.isClosed) {
      return false;
    }

    return (this.task.possibleActions & PossibleUpdates.DeleteAllowed) === PossibleUpdates.DeleteAllowed;
  }

  private endDateDisabledDates(): any {
    const day = new Date(this.taskData.startDate);
    day.setDate(day.getDate() + 1);

    return {
      to: this.taskData.startDate,
      from: this.project.endDate,
    };
  }

  private startDateDisabledDates(): any {
    return {
      to: this.project.startDate,
      from: this.project.endDate,
    };
  }

  private async employeeSelected(id: string) {
    this.taskData.employeeId = id;
    await this.taskChanged();
  }

  private mounted() {
    this.taskData = { ...this.task };
    this.taskData.category = this.category.name;
  }

  private async taskChanged() {
    if (this.taskData.newTask) {
      if (this.taskData.name !== '' && this.taskData.employeeId !== '') {
        await this.createTask(this.taskData);
      }
    } else {
      try {
        await this.updateTask(this.taskData);
      } catch {
        // Reset task to initial value
        this.taskData = { ...this.task };
        this.taskData.category = this.category.name;
        const employee = this.employees.find((e) => e.employeeId === this.task.employeeId);
        (this.$refs.emplist as any).select(employee);
      }
    }
  }
}
